module.exports = __webpack_public_path__ + "img/ZAHNMUND_kachel_mundspuelung.2f59fc4c.png";